function initHeroViewers() {
  document.querySelectorAll(".page-hero__viewer[data-video-id]").forEach(function (el, idx) {
    if (el.dataset.initialized === "true") return;

    var videoId = el.getAttribute("data-video-id");
    if (!videoId) return;

    var containerId = "hero-s7viewer-" + idx;
    el.id = containerId;
    el.dataset.initialized = "true";

    var viewer = new s7viewers.VideoViewer({
      containerId: containerId,
      params: {
        asset: videoId,
        config: "bhsf/High_InitialBitRate",
        serverurl: "https://s7d9.scene7.com/is/image/",
        contenturl: "https://s7d9.scene7.com/is/content/",
        videoserverurl: "https://s7d9.scene7.com/is/content",
        autoplay: "1",
        loop: "1",
        mute: "1",
        controls: "none"
      },
      handlers: {
        initComplete: function () {
          var s7container = el.querySelector(".s7container");
          if (s7container) {
            s7container.removeAttribute("role");
          }

          var player = viewer.videoplayer;
          if (player) {
            var videoEl = el.querySelector('video');
            if (videoEl) {
              videoEl.muted = true;
              videoEl.setAttribute('muted', '');
            }

            player.mute();
            player.set
            player.play();
          }
          var controls = el.querySelector(".s7controlbar");
          if (controls) {
            controls.style.display = "none";
          }

          const controlButton = document.querySelector("#page-hero-control-button");
          if (!controlButton) return;

          controlButton.classList.add("is-ready");

          controlButton.addEventListener("click", function () {
              if (controlButton.getAttribute("aria-pressed") === "false") {
                player.pause();
                controlButton.classList.remove('button--pause');
                controlButton.classList.add('button--play-alt');
                controlButton.setAttribute("aria-pressed", "true");
              } else {
                player.play();
                controlButton.classList.remove('button--play-alt');
                controlButton.classList.add('button--pause');
                controlButton.setAttribute("aria-pressed", "false");
              }
          });
        }
      }
    });

    viewer.init();
    el.viewer = viewer;
  });
}

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".page-hero__viewer[data-video-id]")) {
    Scene7Loader.load(initHeroViewers);
  }
});
